import { useState, useContext } from "react";
import { AuthContext } from "../../../context/authContext";
import makeRequest from "../../../utils/axios";
import Swal from "sweetalert2";

export const useSettings = () => {
    const { currentUser, setCurrentUser } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const updateAccount = async (inputs) => {
        setLoading(true);
        try {
            const res = await makeRequest.put("/users/account", inputs);
            setCurrentUser({ ...currentUser, ...inputs });
            Swal.fire("Success", res.data, "success");
        } catch (err) {
            Swal.fire("Error", err.response?.data || "An error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

    const updatePassword = async (passwords) => {
        if (passwords.newPassword !== passwords.confirmPassword) {
            return Swal.fire("Error", "The confirmation password does not match!", "error");
        }
        setLoading(true);
        try {
            const res = await makeRequest.put("/users/password", {
                currentPassword: passwords.currentPassword,
                newPassword: passwords.newPassword
            });
            Swal.fire("Success", res.data, "success");
        } catch (err) {
            Swal.fire("Error", err.response?.data || "An error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

    const updatePrivacy = async (privacyData) => {
        setLoading(true);
        try {
            const res = await makeRequest.put("/users/privacy", privacyData);
            setCurrentUser({ ...currentUser, ...privacyData });
            Swal.fire("Success", res.data, "success");
        } catch (err) {
            Swal.fire("Error", err.response?.data || "An error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

    return { 
        updateAccount, 
        updatePassword, 
        updatePrivacy,
        loading, 
        currentUser 
    };
};